import Box from '@mui/material/Box';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import ListItemButton from '@mui/joy/ListItemButton';
import { getMUICache, appendStyleSheet, fetchAnchorValue } from "../../common/utils"
import { CacheProvider } from '@emotion/react';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
// import { Button } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
import "./mainMenu.css";
import HomeIcon from '@mui/icons-material/Home';
import { ENDUSER_PAGE } from '../Common/Constant';
import bcrypt from 'bcryptjs-react';


MainMenu.version = 1000;

MainMenu.lang = 'en';
MainMenu.langs = [
  'en'
];
MainMenu.setLang = (lang: any) => {
  MainMenu.lang = lang;
}

Object.defineProperty(MainMenu, 'name', {
  writable: true,
  value: 'MainMenu'
});

export default function MainMenu(props: any) {
  const { menuItems, domainUrl, toggleMainMenu, headerMenuEndpoint, cdsDomain, noOfHeaderItems, anchorLinksValue } = props;
  let styles = require("./mainMenu.css");
  appendStyleSheet("MainMenu", styles);


  const getUrl = (domainUrl: string, path: string) => {
    if (!domainUrl) { return }
    let updatedDomain = domainUrl;
    if (domainUrl.length > 0 && domainUrl[domainUrl.length - 1] == "/") {
      updatedDomain = domainUrl.substring(0, domainUrl.length - 1)
    }
    if (path.includes("http://") || path.includes("https://")) {
      updatedDomain = path;
    } else {
      updatedDomain = updatedDomain + path;
    }

    return updatedDomain;
  }

  const getSubMenu = (subMenuItems: any) => {
    if (!Array.isArray(subMenuItems)) {
      console.warn("Invalid subMenuItems:", subMenuItems);
      return null;
    }
    return <div className="submenuItems">
      {
        subMenuItems.map((subMenuItem: any, index: number) => {
          let urlPath = subMenuItem.path;
          if (subMenuItem.type === 2) {
            urlPath = '/tags/' + (subMenuItem.tagpath !== undefined ? subMenuItem.tagpath : '');
          }
          return <div className='subMenuli' key={'mmi__' + index} itemProp="name" content={subMenuItem.name}>
            <a key={'mmia__' + index} href={getUrl(domainUrl, urlPath)} target={fetchAnchorValue(anchorLinksValue, urlPath)} itemProp="url" content={getUrl(domainUrl, urlPath)}>{subMenuItem.name}</a>
            </div>
        }
        )
      }
    </div>
  }

  const renderMoreOption = () => {
    let optionData = menuItems?.slice(noOfHeaderItems, menuItems.length);

    if (!Array.isArray(optionData)) {
      console.warn("Invalid optionData:", optionData);
      return null;
    }

    return <li className="nav-item">
      <ListItemButton key="test" component="a" className="has-submenu">More</ListItemButton>
      <ul className="submenu">
        {optionData.map((menuItem: any, index: number) =>
          <li key={index} className='submenu-item ' itemProp="name" content={menuItem.name}>
            <a href={menuItem.path} itemProp="url" content={getUrl(domainUrl, menuItem.path)}>{menuItem.name}</a>
          </li>
        )}

      </ul>
    </li>
  }

  const checkIfActive = (name: string) => {

    if (typeof window !== 'undefined' && window && window.location && window.location.pathname) {
      const pathName = window.location.pathname.toLowerCase();
      const nameLowerCase = name?.toString()?.toLowerCase();

      if (pathName.indexOf("/" + nameLowerCase + "/") >= 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  const getMenuData = () => {
    if (!Array.isArray(menuItems)) {
      console.error('menuItems is not an array or is undefined');
      return [];
    }
    // let menuData = menuItems.slice(0, 9);

    let menuData = menuItems.slice(0, noOfHeaderItems);

    let moreOption: any;
    if (menuData && menuData.length > 0 && menuData.some((item: any) => item && item.secid === '123')) {
      if (typeof window !== 'undefined' && window) {
        const { pathname } = window.location;
        const splitPath = pathname.split('/');
        const secondLastSegment = splitPath[splitPath.length - 2];
        if (ENDUSER_PAGE.includes(secondLastSegment)) {
          callNavApi(menuData, headerMenuEndpoint.queryParams.hostId);
          menuData = menuData.map((item: any) => {
            if (item && item.secid === '123') {
              return { ...item, name: <HomeIcon />, key: 123 };
            }
            return item;
          });
        }
      }
    }

    let data = menuData.map((menuItem: any, index: number) => {
      if (menuItem) {
        let isActive = checkIfActive(menuItem.name);

        let urlPath = menuItem.path;
        if (menuItem.type === 2) {
          urlPath = '/tags/' + (menuItem.tagpath !== undefined ? menuItem.tagpath : '');
        }

        return <ListItem key={'kk_' + index} className={`menuItem ${isActive ? "active" : ""}`} itemProp="name" content={menuItem.name}>
          <div key={'00_' + index}>
            <ListItemButton key={'111_' + index} component="a" href={getUrl(domainUrl, urlPath)} target={fetchAnchorValue(anchorLinksValue, urlPath)} itemProp="url" content={getUrl(domainUrl, urlPath)}>{menuItem.name} </ListItemButton>
            {menuItem.sections && menuItem.sections.length > 0 && getSubMenu(menuItem.sections)}
          </div>
        </ListItem>
      }
    })

    if (menuItems.length > noOfHeaderItems) {
      moreOption = renderMoreOption();
    }

    // console.log("Generated Menu Data:", [...data, moreOption]);

    return [...data, moreOption];
  }

  function callNavApi(menuData: any, hostId: any) {
    if (typeof window !== 'undefined' && undefined !== window && window) {
      const pathName = window.location.pathname;
      const pathArray = pathName.split('/');
      let msid = pathArray[pathArray.length - 1];
      msid = msid.split('.')[0];
      const url = `${cdsDomain}/cds-feed-ext/listing/get/m360?msid=${msid}&fv=1000&hostId=${hostId}&pp=4&cp=1&apiType=nav`;

      let headerString = '?' + url.split("?")[1];
      headerString = bcrypt.hashSync(headerString, 6);
      const headers = { 'p-nonce': headerString };

      const fetch1 = require('sync-fetch');
      const pr = fetch1(url, { headers: headers });
      const statusCode = pr.status;
      let response = [];
      try {
        response = pr.json();
      } catch (error: any) {
        console.error('Error:', error.message);
      }
      if (statusCode === 200) {
        if (response) {
          const firstElement = response.items[0];
          let item = null;
          if (pathArray.includes('articleshow') || pathArray.includes('videoshow') || pathArray.includes('podcast') || pathArray.includes('photoshow')) {
            item = { name: firstElement.hl, secid: '456', path: firstElement.wu, type: 1 }
          } else if (pathArray.includes('articlelist') || pathArray.includes('photolist') || pathArray.includes('videolist') || pathArray.includes('webstorylist') || pathArray.includes('podcastlist')) {
            item = { name: response.title, secid: '456', path: pathName, type: 1 }
          }
          //menuData.unshift(item);
          menuData.splice(1, 0, item);
        }
      }
    }
  }

  return (
    <CacheProvider value={getMUICache()}>
      <Box sx={{ minHeight: 19 }} className="mainMenu">
        <div className='navbar'>
          <div className="sidebar-menu-icon" onClick={toggleMainMenu}>
            <IconButton size="large" edge="start" color="inherit" aria-label="open drawer" sx={{ mr: 2 }}>
              <MenuIcon />

            </IconButton>
            {/* <Button className="closebtn" onClick={toggleMainMenu}><CloseIcon /></Button> */}
          </div>
          <List
            orientation="horizontal"
            sx={{
              '--List-padding': '4px',
              '--List-gap': '0px',
              '--ListItem-paddingX': '7px',
              '--ListItem-paddingY': '0',
              padding: "0"
            }}
            itemType="http://www.schema.org/SiteNavigationElement"
            itemScope={true}
          >
            {getMenuData().map((menu, index) => (
              <div key={index}>{menu}</div>
            ))}
          </List>
        </div>
      </Box>
    </CacheProvider>
  );
}